<script>
import UploadList from "./upload-list";
import Upload from "./upload";
import ElProgress from "element-ui/packages/progress";
import Migrating from "element-ui/src/mixins/migrating";
import { finishUpload } from "@/api/ei/eiMallApi";

function noop() {}

export default {
  name: "ElUpload",

  mixins: [Migrating],

  components: {
    ElProgress,
    UploadList,
    Upload,
  },

  provide() {
    return {
      uploader: this,
    };
  },

  inject: {
    elForm: {
      default: "",
    },
  },

  props: {
    action: {
      type: String,
      required: true,
    },
    headers: {
      type: Object,
      default() {
        return {};
      },
    },
    data: Object,
    multiple: Boolean,
    name: {
      type: String,
      default: "file",
    },
    drag: Boolean,
    dragger: Boolean,
    withCredentials: Boolean,
    showFileList: {
      type: Boolean,
      default: true,
    },
    accept: String,
    type: {
      type: String,
      default: "select",
    },
    beforeUpload: Function,
    beforeRemove: Function,
    onRemove: {
      type: Function,
      default: noop,
    },
    onChange: {
      type: Function,
      default: noop,
    },
    onPreview: {
      type: Function,
    },
    onSuccess: {
      type: Function,
      default: noop,
    },
    onProgress: {
      type: Function,
      default: noop,
    },
    onError: {
      type: Function,
      default: noop,
    },
    fileList: {
      type: Array,
      default() {
        return [];
      },
    },
    autoUpload: {
      type: Boolean,
      default: true,
    },
    listType: {
      type: String,
      default: "text", // text,picture,picture-card
    },
    httpRequest: Function,
    disabled: Boolean,
    limit: Number,
    onExceed: {
      type: Function,
      default: noop,
    },
    uploadStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
    aimPath: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      uploadFiles: [],
      dragOver: false,
      draging: false,
      tempIndex: 1,
    };
  },

  computed: {
    uploadDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
  },

  watch: {
    listType(type) {
      if (type === "picture-card" || type === "picture") {
        this.uploadFiles = this.uploadFiles.map((file) => {
          if (!file.url && file.raw) {
            try {
              file.url = URL.createObjectURL(file.raw);
            } catch (err) {
              console.error("[Element Error][Upload]", err);
            }
          }
          return file;
        });
      }
    },
    fileList: {
      immediate: true,
      handler(fileList) {
        const usedUids = Object.create(null);
        this.uploadFiles = fileList.map((item) => {
          let uid = item.uid;
          if (!uid || usedUids[uid]) {
            do {
              uid = Date.now() + this.tempIndex++;
            } while (usedUids[uid]);
          }
          usedUids[uid] = true;
          return Object.assign({}, item, {
            uid,
            status: item.status || "success",
            icon: item.icon || "clip",
          });
        });
      },
    },
  },

  methods: {
    handleStart(rawFile) {
      rawFile.uid = Date.now() + this.tempIndex++;
      let file_type = rawFile.name
        .substring(rawFile.name.lastIndexOf("."))
        .toLowerCase();
      let file = {
        status: "ready",
        name: rawFile.name,
        size: rawFile.size,
        percentage: 0,
        uid: rawFile.uid,
        raw: rawFile,
        ext: file_type,
      };

      if (this.listType === "picture-card" || this.listType === "picture") {
        try {
          file.url = URL.createObjectURL(rawFile);
        } catch (err) {
          console.error("[Element Error][Upload]", err);
          return;
        }
      }

      this.uploadFiles.push(file);
      this.onChange(file, this.uploadFiles);
    },
    handleProgress(ev, rawFile, cpt, res) {
      const file = this.getFile(rawFile);
      this.onProgress(ev, file, this.uploadFiles, cpt, res);
      file.status = "uploading";
      file.percentage = ev * 100 || 0;
    },
    handleSuccess(res, rawFile) {
      const file = this.getFile(rawFile);
      let end = res.res.requestUrls[0].indexOf("?");
      let path = "";
      if (end > -1) {
        path = res.res.requestUrls[0].substring(0, end);
      } else {
        path = res.res.requestUrls[0];
      }
      //上传登记
      finishUpload({
        filename: file.name,
        url: path,
      }).then((re) => {
        if(!re.errno){
          if (file) {
            file.status = "success";
            file.response = re;
            this.onSuccess(re, file, this.uploadFiles);
            this.onChange(file, this.uploadFiles);
          }
        } else {
          this.handleError(re.message, rawFile);
        }
      }).catch(err => {
        this.handleError(err, rawFile);
      });
    },
    handleError(err, rawFile) {
      const file = this.getFile(rawFile);
      const fileList = this.uploadFiles;

      file.status = "fail";

      fileList.splice(fileList.indexOf(file), 1);

      this.onError(err, file, this.uploadFiles);
      this.onChange(file, this.uploadFiles);
    },
    handleRemove(file, raw) {
      if (raw) {
        file = this.getFile(raw);
      }
      let doRemove = () => {
        this.abort(file);
        let fileList = this.uploadFiles;
        fileList.splice(fileList.indexOf(file), 1);
        this.onRemove(file, fileList);
      };

      if (!this.beforeRemove) {
        doRemove();
      } else if (typeof this.beforeRemove === "function") {
        const before = this.beforeRemove(file, this.uploadFiles);
        if (before && before.then) {
          before.then(() => {
            doRemove();
          }, noop);
        } else if (before !== false) {
          doRemove();
        }
      }
    },
    getFile(rawFile) {
      let fileList = this.uploadFiles;
      let target;
      fileList.every((item) => {
        target = rawFile.uid === item.uid ? item : null;
        return !target;
      });
      return target;
    },
    abort(file) {
      this.$refs["upload-inner"].abort(file);
    },
    clearFiles() {
      this.uploadFiles = [];
    },
    submit() {
      this.uploadFiles
        .filter((file) => file.status === "ready")
        .forEach((file) => {
          this.$refs["upload-inner"].upload(file.raw);
        });
    },
    getMigratingConfig() {
      return {
        props: {
          "default-file-list": "default-file-list is renamed to file-list.",
          "show-upload-list": "show-upload-list is renamed to show-file-list.",
          "thumbnail-mode":
            "thumbnail-mode has been deprecated, you can implement the same effect according to this case: http://element.eleme.io/#/zh-CN/component/upload#yong-hu-tou-xiang-shang-chuan",
        },
      };
    },
    handleChange(files) {
      this.fileList.forEach((file, index) => {
        file.name = files[index].name;
      });
    },
  },

  beforeDestroy() {
    this.uploadFiles.forEach((file) => {
      if (file.url && file.url.indexOf("blob:") === 0) {
        URL.revokeObjectURL(file.url);
      }
    });
  },

  render(h) {
    let uploadList;

    if (this.showFileList) {
      uploadList = (
        <UploadList
          disabled={this.uploadDisabled}
          listType={this.listType}
          files={this.uploadFiles}
          on-remove={this.handleRemove}
          on-change={this.handleChange}
          handlePreview={this.onPreview}
        >
          {(props) => {
            if (this.$scopedSlots.file) {
              return this.$scopedSlots.file({
                file: props.file,
              });
            }
          }}
        </UploadList>
      );
    }

    const uploadData = {
      props: {
        type: this.type,
        drag: this.drag,
        action: this.action,
        multiple: this.multiple,
        "before-upload": this.beforeUpload,
        "with-credentials": this.withCredentials,
        headers: this.headers,
        name: this.name,
        data: this.data,
        accept: this.accept,
        uploadStyle: this.uploadStyle,
        fileList: this.uploadFiles,
        autoUpload: this.autoUpload,
        listType: this.listType,
        disabled: this.uploadDisabled,
        limit: this.limit,
        "on-exceed": this.onExceed,
        "on-start": this.handleStart,
        "on-progress": this.handleProgress,
        "on-success": this.handleSuccess,
        "on-error": this.handleError,
        "on-preview": this.onPreview,
        "on-remove": this.handleRemove,
        "http-request": this.httpRequest,
        "aimPath": this.aimPath,
      },
      ref: "upload-inner",
    };

    const trigger = this.$slots.trigger || this.$slots.default;
    const uploadComponent = <upload {...uploadData}>{trigger}</upload>;

    return (
      <div>
        {this.listType === "picture-card" ? uploadList : ""}
        {this.listType !== "picture-card" ? uploadList : ""}
        {this.$slots.trigger
          ? [uploadComponent, this.$slots.default]
          : uploadComponent}
        {this.$slots.tip}
      </div>
    );
  },
};
</script>
